import { useState } from "react";

function FAQSection() {
    const [open, setOpen] = useState(0);

    const handleClick = (i) => {
        if (open === i) setOpen(prev => 0);
        else setOpen(prev => i);
    }

    return (
        <section>
            <div className="faqs">
                <h3>FAQs</h3>
                <div>
                    <div className={open === 1 ? "faq faq-open" : "faq"} onClick={() => handleClick(1)}>Is psychotherapy the same as counselling?</div>
                    <div className={open === 1 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            While the two terms are often used interchangeably, counselling tends to refer to
                            shorter-term work, perhaps several weeks or months. Counsellor and client may focus
                            on a specific issue which the client is facing, this being agreed at the start. While
                            counselling may involve some exploration of the client’s history, the focus tends to
                            be much more on their present life situation.
                        </p>
                        <p>
                            Psychotherapy usually refers to longer term work, aimed at a deeper understanding of
                            one’s emotions and patterns of behaviour. This involves exploring how early life experiences
                            may be influencing you now. While psychotherapy aims at helping people feel better, it is
                            also open to deeper questions such as Who am I deep down? What gives my life meaning? How
                            did I become the person I am? Unlike counselling, which is more structured, psychotherapy
                            tends to take a more open approach, working with what comes up in each session.
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 2 ? "faq faq-open" : "faq"} onClick={() => handleClick(2)}>How many sessions will I need?</div>
                    <div className={open === 2 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            The number of sessions needed differs for everyone and depends on the depth of the issues
                            being worked on. Most of the work I do with clients tends to be long-term and open-ended but
                            if you are interested in short-term counselling, I am very happy to discuss this with you.
                        </p>
                        <p>
                            When we begin, we will agree an initial number of sessions, generally between 6 and 8. At
                            the end of this period, we will review how it has been to work together, and consider what
                            goals might be appropriate for the therapy moving forwards.
                        </p>
                        <p>
                            Ultimately, how long the therapy lasts is your decision, and I consider it important that it
                            continue only as long as it benefits you.
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 3 ? "faq faq-open" : "faq"} onClick={() => handleClick(3)}>Can I bring a friend or relative with me?</div>
                    <div className={open === 3 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            With therapy it's important you feel free to talk about whatever you need to. Often, it is
                            only once therapy gets underway that issues which need exploring become clear. Partners,
                            family or friends, even though they want to help, will likely have their own ideas about
                            what you need. They may also be connected to issues you need to explore meaning their presence
                            could prevent you from speaking freely.
                        </p>
                        <p>
                            It is perfectly normal to feel anxious before coming for a session alone, but you will not be
                            pushed to talk about anything you don’t feel ready to. However, you do need to be able to talk
                            about what feels important. Because of this, I do not see clients with family or friends.
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 4 ? "faq faq-open" : "faq"} onClick={() => handleClick(4)}>Will everything I say be confidential?</div>
                    <div className={open === 4 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            Confidentiality is one of the aspects of the therapist-client relationship that makes it possible
                            to bring whatever needs to be explored, including things that may feel painful or embarrassing.
                        </p>
                        <p>
                            No therapist, however, can offer 100% confidentiality. There are some situations where risk must
                            be disclosed, for instance if a child or vulnerable adult is in danger. Also, if I have reason to
                            believe someone is going to seriously harm themselves, or do something that could harm others, it
                            may be necessary and ethical for me to break confidentiality. However, this course of action is rare,
                            and I would always endeavour to discuss it with you first.
                        </p>
                        <p>
                            At the assessment stage, I explain my policy regarding confidentiality in more detail. This is also
                            an opportunity for you to ask any questions or clarify anything you feel concerned about.
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 5 ? "faq faq-open" : "faq"} onClick={() => handleClick(5)}>Can I have an initial session before committing?</div>
                    <div className={open === 5 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            I offer a free 15-minute call (phone or video) to answer any questions you might have about
                            the therapy and how I work. The next step is to arrange an assessment, where I can learn a bit
                            more about you and the issues you are facing. The assessment is also a chance for us to get a
                            sense of what working together could be like.
                        </p>
                        <p>
                            If we decide to go ahead with the therapy, we will agree an initial number of sessions, typically
                            around 6-8, after which we will review how it has been and potentially set some goals moving forwards.
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 6 ? "faq faq-open" : "faq"} onClick={() => handleClick(6)}>Why do I need an assessment and what can I expect?</div>
                    <div className={open === 6 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            In the assessment, we will explore your reasons for seeking therapy, a bit about your life history,
                            and what you are hoping to achieve. It is an important opportunity for us to get to know each other
                            and make sure I am the right therapist for you.
                        </p>
                        <p>
                            The assessment is different to a normal therapy session. To understand your needs, I will need to
                            ask questions not only about your current situation but about your history, including childhood and
                            family. I will take notes during the session, which will not happen in regular therapy sessions. I
                            will also ask for information about your mental health history, including any diagnoses you might
                            have been given, or medication you have been prescribed.
                        </p>
                        <p>
                            Occasionally, it could be that another therapist, perhaps one who specialises in an area relevant to
                            the issues you are facing, could serve your needs better. In such cases, I will endeavour to help you
                            seek the support you need.
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 7 ? "faq faq-open" : "faq"} onClick={() => handleClick(7)}>What is your cancellation policy?</div>
                    <div className={open === 7 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            If you need to cancel a session, I ask for 3 days’ notice by email. In the case of cancellations
                            made with less than 3 days’ notice, or if scheduled sessions are missed, the full fee is payable.
                        </p>
                        <p>
                            While there will of course be times when you have to cancel a session, or take breaks for holidays,
                            therapy does require consistency and commitment. This begins with therapist and client agreeing to
                            meet each week at a particular time, creating a dedicated space which is there for you to explore
                            whatever you need to.
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 8 ? "faq faq-open" : "faq"} onClick={() => handleClick(8)}>What are your qualifications?</div>
                    <div className={open === 8 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            Integrative Transpersonal Psychotherapy, Centre for Counselling and Psychotherapy, Advanced Post
                            Graduate Diploma in Integrative and Transpersonal Psychothe, Graduated 2022
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 9 ? "faq faq-open" : "faq"} onClick={() => handleClick(9)}>What kind of therapist are you?</div>
                    <div className={open === 9 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            As an Integrative Psychotherapist, I do not believe that one therapeutic approach can help
                            everyone and I strive to find the right approach for each individual client. My practice is
                            informed by a range of long-established therapeutic approaches, comprised mainly of relational
                            psychoanalysis, humanistic theory, attachment theory etc… My work also includes a
                            trauma-informed perspective and is grounded in the latest findings in neuroscience.
                        </p>
                        <p>
                            Psychodynamic: looks at how current relationships and emotions are influenced by unconscious
                            patterns and past experiences, particularly those of childhood.
                        </p>
                        <p>
                            Humanistic: views every person as having an innate drive to realize their potential and become
                            their true self. This approach values authenticity, empathy, and warmth.
                        </p>
                        <p>
                            Existential: explores the fundamental questions and challenges of human existence such as freedom,
                            death, responsibility, meaning and purpose.
                        </p>
                        <p>
                            Transpersonal: a holistic approach that goes beyond individual psychology to explore the transcendent
                            side of human experience. This approach is open to the role played by the spiritual in an individual’s
                            life, whatever this means for them. My training had a particular focus on transpersonal ways of working.
                        </p>
                        <p>
                            I understand these concepts may be foreign to most people and I am happy to clarify them during
                            our first consultation if you would like to know more. But to put it simply, the work we do together
                            tends to involve a combination of focusing on current issues, examining the past and processing
                            emotions so that they become less troublesome.
                        </p>
                        <br />
                    </div>
                </div>
                <div>
                    <div className={open === 10 ? "faq faq-open" : "faq"} onClick={() => handleClick(10)}>Where can I read testimonials and reviews?</div>
                    <div className={open === 10 ? "faq-answer faq-open" : "faq-answer"}>
                        <br />
                        <p>
                            The UK Council for Psychotherapy (UKCP) prohibits using client testimonials in advertising. This is to
                            uphold the fundamental principles of confidentiality, privacy, and the protection of the therapeutic
                            relationship.
                        </p>
                        <br />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FAQSection;